import * as React from "react";
import { getExpressData, putExpressData } from "@/pages/ExpressForm/express-data";
import { lookup } from "@/services/api/formApi";
import { ServiceProvider } from "@/types/ServiceProvider";
import { SPContext } from "@/store/SPProvider";

export const useServiceProvider = (slug: string) => {
  const [{ serviceProvider, loading, error }, setState] = React.useState({
    serviceProvider: null as ServiceProvider | null,
    loading: true,
    error: null as Error | null,
  });
  const { dispatch } = React.useContext(SPContext);

  React.useEffect(() => {
    let isMounted = true;

    lookup({ slug }).then(
      (sp) => {
        if (!isMounted) return;

        const data = getExpressData();
        if (data?.slug !== slug) {
          putExpressData({ slug });
        }
        setState({
          serviceProvider: sp,
          loading: false,
          error: null,
        });
        dispatch({ type: "SET_SP", payload: sp });
      },
      (_error) => {
        if (!isMounted) return;
        setState({ serviceProvider: null, loading: false, error: new Error("Not found") });
      }
    );

    return () => {
      isMounted = false;
    };
  }, [slug, dispatch]);

  return { serviceProvider, loading, error };
};
